/* Common imports */

import fsPromises from "fs/promises";
import React from "react";

/*

 * component imports

 */

import Layout from "../../../components/layout-components/Layout";
import Fabs from "../../../components/page-sections/SingleProperty/sub-components/FabContent/Fabs";

// const ImagesSection = loadable(() => import("../../../components/page-sections/SingleProperty/ImagesSection"));

import PropertyTitleSection from "../../../components/page-sections/SingleProperty/sub-components/PropertyTitleSection";

import dynamic from "next/dynamic";
import SectionTwo from "../../../components/page-sections/SingleProperty/sub-components/SectionTwo";

const SuggestedPropertiesScorll = dynamic(
	() => import("../../../components/page-sections/SingleProperty/sub-components/SuggestedPropertiesScorll"),
);

// const CardCarousel = loadable(() => import("../../../components/page-sections/Index/CardCarousel"));
/* @mui imports */
import { styled, Theme } from "@mui/material/styles";

/* Redux imports */

import { connect } from "react-redux";
import { PropertyInterface } from "../../../models";
import StateInterface from "../../../redux-magic/state-interface";
import {
	fetchAboutSinglePropertyThunk,
	fetchSinglePropertyAmenitiesThunk,
	fetchSinglePropertyConfigAndAreaThunk,
	fetchSinglePropertyCreatorThunk,
	fetchSinglePropertyDetailsThunk,
	fetchSinglePropertyDeveloperThunk,
	fetchSinglePropertyHotPropertiesThunk,
	fetchSinglePropertyImagesThunk,
	fetchSinglePropertyLocationCoordinatesThunk,
	fetchSinglePropertyNeighbourhoodReviewsThunk,
	fetchSinglePropertyOverviewThunk,
	fetchSinglePropertyReviewsThunk,
	fetchSinglePropertyTrendingPropertiesThunk,
	fetchSinglePropertyVicinityThunk,
	setImageCategoryThunk,
	updateReduxSessionThunk,
	updateSearchFilterSelectedOptionsThunk,
	wrapper,
} from "../../../redux-magic/store";
import { SearchFilterId } from "../../../redux-magic/sub-interfaces/search-types";
import {
	BusinessProfileInterface,
	ClickerType,
	ClickInterface,
	MousePositionType,
	PropertySnackbarInterface,
	QueryStringParameterType,
	TargetType,
	UserInterface,
} from "../../../redux-magic/sub-interfaces/sub-interfaces";
import fallback_location from "../../../redux-magic/sub-state-data/location-lat-lng";
import fallback_single_property_page from "../../../redux-magic/sub-state-data/single-property-page";
import {
	bottom_subscribe_buy_beegru_points,
	data_before_edit,
	notifications_page,
	section_to_edit,
} from "../../../redux-magic/sub-state-data/sub-state-data";
import { updateSearchFilterAppliedThunk } from "../../../redux-magic/thunks";

/* Other imports */

import { ObjectId } from "bson";
import { useRouter } from "next/router";

/*

? Library imports

*/

import { useInView } from "react-intersection-observer";

interface adminInterface {
	_id: string | ObjectId;
	admins: Array<{}>;
}

interface LocalPropertyInterface extends Omit<PropertyInterface, "created_by"> {
	created_by: {
		is_business_profile: boolean;
		business_profile_id: string | ObjectId | BusinessProfileInterface;
		user_id: string | ObjectId | UserInterface;
	};
}

/* Security library*/

import { GetServerSidePropsContext } from "next";
import path from "path";
import CardCarousel from "../../../components/page-sections/Index/CardCarousel";
import { createLoginFlow, LoginFlowTriggers, validateClientSession } from "../../../lib/auth/helpers";
import authenticationTokenGenerator from "../../../lib/authentication_token_generator";
import openViewTrackingWebsocket from "../../../lib/OpenViewTrackingWebsocket";
import searchResultsToPropertyMapSQS from "../../../lib/searchResultsToPropertyMapSQS";
import storeUTMSourceSQS from "../../../lib/storeUTMSourceSQS";
import Four0Four from "../../404";

export const getServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (context: GetServerSidePropsContext) => {
		/*

		& Let's get the slug from the context.

		*/
		const slug = context.params ? (context.params.slug as string) : "";

		/*

		& Let's get the metadata from the slug. We are using the ReadJSON function to get the metadata.

		*/
		// const metadata = await ReadJSON({ slug: slug });
		let metadata = null;
		try {
			metadata = JSON.parse(
				(
					await fsPromises.readFile(path.join(process.cwd(), "public/cache/metadata/properties/" + slug + ".json"))
				).toString(),
			);

			if (!metadata || metadata.title === undefined || metadata.title.length <= 0) {
				throw new Error("Metadata not found");
			}
		} catch (error) {
			metadata = await (
				await fetch("https://metadata.properties.beegru.com", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						last_executed_at: new Date().toString(),
						slug: slug,
						update_all: true,
					}),
				})
			).json();
		}

		/*


		& Let's get the session from the context.

		*/
		const server_session = await authenticationTokenGenerator(context);

		/*

		& Let's get the search log id from the context.

		*/
		const search_log_id = context.query.search_log_id
			? context.query.search_log_id.includes("undefined")
				? undefined
				: (context.query.search_log_id as string)
			: undefined;

		if (search_log_id !== undefined) {
			const results = await searchResultsToPropertyMapSQS(search_log_id, slug, server_session);
		}

		/*

		Extract UTM parameters from the context (if any)

		*/

		const utm_source: string | null = context
			? context.query
				? context.query.utm_source
					? context.query.utm_source.toString().length > 0
						? context.query.utm_source.toString()
						: null
					: null
				: null
			: null;

		const utm_source_id: string | null = context
			? context.query
				? context.query.utm_source_id
					? context.query.utm_source_id.toString().length > 0
						? context.query.utm_source_id.toString()
						: null
					: null
				: null
			: null;

		const simple_campaign_id = new ObjectId();

		if (!!utm_source && !!utm_source_id) {
			const utm = await storeUTMSourceSQS(utm_source, utm_source_id, simple_campaign_id);
		}

		return {
			props: {
				server_session: server_session,
				slug: slug,
				metadata: metadata,
				simple_campaign_id: simple_campaign_id.toString(),
			},
		};
	},
);

/*

& Let's declare a static bson object id to be used as a fallback in case the session is not available.

*/

const oid = new ObjectId().toHexString();

/*

& Let's declare the component.

*/

/* stylings */

const ContainerOne = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
}));

interface LocalPropertyInterface extends Omit<PropertyInterface, "created_by"> {
	created_by: {
		is_business_profile: boolean;
		business_profile_id: string | ObjectId | BusinessProfileInterface;
		user_id: string | ObjectId | UserInterface;
	};
}

const Properties = ({
	property,
	category,
	dispatch,
	server_session,
	session,
	redux_session,
	ogImageParams,
	index,
	theme,
	showInactivityDialog,
	location,
	profile_context,
	new_business_profile_url,
	new_listing_url,
	sectionToEdit,
	dataBeforeEdit,
	property_loading,
	property_snackbar,
	notification_data,
	newNotification,
	OgObjectDetails,
	view_time_spent_id,
	slug,
	metadata,
	newPropertyData,
	newServiceData,
	searchanimationsettings,
	bottom_beegru_points,
	search_filter_state,
	search_filter_metrices,
	SeacrhApiResponse,
	simple_campaign_id,
	login_flow_global_state,
}: {
	property?: StateInterface["single_property_page"];
	category?: StateInterface["category"];
	dispatch: Function;
	index: number;
	server_session: any;
	session: any;
	redux_session: StateInterface["redux_session"];
	ogImageParams?: {
		ogImageSquareUrl: string;
		ogImageRectangleUrl: string;
		ogImageSquareType: string;
		ogImageRectangleType: string;
		ogImageSquareWidth: number;
		ogImageSquareHeight: number;
		ogImageRectangleWidth: number;
		ogImageRectangleHeight: number;
	};
	OgObjectDetails?: {
		title: string;
		description: string;
		location_title: string;
		property_type: string;
		transaction_type: string;
		price: number;
	};
	theme: Theme;
	showInactivityDialog: boolean;
	location: StateInterface["location"];
	profile_context: StateInterface["profile_context"];
	new_business_profile_url: StateInterface["new_business_profile_url"];
	new_listing_url: StateInterface["new_listing_url"];
	sectionToEdit: StateInterface["section_to_edit"];
	dataBeforeEdit: StateInterface["data_before_edit"];
	property_loading?: StateInterface["property_loading"];
	property_snackbar?: StateInterface["property_snackbar"];
	notification_data: StateInterface["notifications_page"];
	newNotification?: StateInterface["notification"] | null;
	view_time_spent_id: StateInterface["view_time_spent_id"];
	slug: string;
	metadata: any;
	newPropertyData: StateInterface["new_property_data"];
	newServiceData: StateInterface["new_service_data"];
	searchanimationsettings: StateInterface["search_animation_settings"];
	bottom_beegru_points: StateInterface["bottom_subscribe_buy_beegru_points"];
	search_filter_state: StateInterface["search_filters_state"];
	search_filter_metrices: StateInterface["search_filter_metrices"];
	SeacrhApiResponse: StateInterface["SeacrhApiResponse"];
	simple_campaign_id: ObjectId;
	login_flow_global_state: StateInterface["login_flow_global_state"];
}) => {
	/*

  & Let's declare the router. Here we are using the useRouter hook from nextjs.

  & We are using the router to get the query params from the url. Memoize the router object to prevent unnecessary re-renders.

  */

	const router = React.useRef(useRouter()).current;

	/* Setting redux_session */

	const [reduxSessionUpdated, setReduxSessionUpdated] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (server_session && validateClientSession(server_session)) {
			dispatch(updateReduxSessionThunk(server_session));
		}
		setReduxSessionUpdated(true);
	}, [server_session, dispatch]);

	const [initialLoad, setInitialLoad] = React.useState<boolean>(true);

	/*

	& Let's declare the 404 and not logged in states to check if the page request is valid.

	^ is_404: boolean - This state is used to check if the page request is a 404.

	^ not_logged_in: boolean - This state is used to check if the user is not logged in. If the Property is not published, the user will be redirected to the login page.

	^ pageRequest: boolean - This state is used to check if the page request is valid.

	*/

	const [is_404, setIs404] = React.useState<boolean>(false);

	const [not_logged_in, setNotLoggedIn] = React.useState<boolean>(false);

	const [pageRequest, setPageRequest] = React.useState<boolean>(false);

	const [mouseScreenX, setMouseScreenX] = React.useState<number>(0);
	const [mouseScreenY, setMouseScreenY] = React.useState<number>(0);
	const [mouseClientX, setMouseClientX] = React.useState<number>(0);
	const [mouseClientY, setMouseClientY] = React.useState<number>(0);
	const [mousePageX, setMousePageX] = React.useState<number>(0);
	const [mousePageY, setMousePageY] = React.useState<number>(0);
	const [mouseOffsetX, setMouseOffsetX] = React.useState<number>(0);
	const [mouseOffsetY, setMouseOffsetY] = React.useState<number>(0);

	const signIn = () => {
		if ((login_flow_global_state?.ui.type || "redirect") === "modal") {
			if (session && session.authorized) {
				new Function(...(login_flow_global_state?.action.sign_in || ["session", "return"])).call(session);
			} else {
				const { startFlow, resetFlow }: LoginFlowTriggers = createLoginFlow({
					dispatch,
					trigger_source: "navbar-dropdown",
					flow_type: "modal",
					autofill: false,
					action: {
						callback_url:
							process.env.PRODUCTION_API_URL +
							"auth/end-session?sessionId=" +
							encodeURIComponent(session?.session_id || "") +
							"&callbackUrl=" +
							encodeURIComponent(router.asPath),
						sign_in: (session: any) => {},
						sign_up: (session: any) => {},
						sign_out: () => {},
					},
				});
				startFlow();
			}
		} else {
		}
	};

	React.useEffect(() => {
		const trackMousePosition = (event: any) => {
			setMouseScreenX(event.screenX);
			setMouseScreenY(event.screenY);
			setMouseClientX(event.clientX);
			setMouseClientY(event.clientY);
			setMousePageX(event.pageX);
			setMousePageY(event.pageY);
			setMouseOffsetX(event.offsetX);
			setMouseOffsetY(event.offsetY);
		};

		const storeClick = async (click: ClickInterface) => {
			await fetch("/api/click-catcher", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(click),
			});
		};

		const trackClick = (event: any) => {
			const click_id: string = new ObjectId().toString();
			const click_clock: Date = new Date();
			const path: string = window.location.pathname;
			const query_string_parameters: Array<QueryStringParameterType> = window.location.search
				? window.location.search
						.substring(1)
						.split("&")
						.map((param: any) => {
							const key: string = param.split("=")[0];
							const value: string = decodeURIComponent(param.split("=")[1]);
							return { key, value };
						})
				: [];
			const mouse_position: MousePositionType = {
				screen_x: event.screenX,
				screen_y: event.screenY,
				client_x: event.clientX,
				client_y: event.clientY,
				page_x: event.pageX,
				page_y: event.pageY,
				offset_x: event.offsetX,
				offset_y: event.offsetY,
			};
			const target: TargetType = {
				element: event.target.outerHTML.toString() || "",
				element_id: event.target.id || "",
				element_type: event.target.type || event.target.tagName.toLowerCase() || "",
			};
			const clicker: ClickerType = {
				is_signed_in: server_session ? (server_session.user ? true : false) : false,
				user_id: server_session
					? server_session.user
						? server_session.user.dbUser
							? server_session.user.dbUser._id
							: click_id
						: click_id
					: click_id,
				user_agent: navigator.userAgent,
				ip_address: "0.0.0.0",
			};
			const click: ClickInterface = {
				_id: click_id,
				created_at: click_clock,
				metadata: {
					_id_copy: click_id,
					path: path,
					query_string_parameters: query_string_parameters,
					mouse_position: mouse_position,
					target: target,
					clicker: clicker,
					updated_at: click_clock,
				},
			};
			/* if no id lets not store it  */
			if (click?.metadata?.target.element_id.includes("spp")) {
				storeClick(click);
			}
		};

		document.addEventListener("mousemove", trackMousePosition);
		document.addEventListener("mouseenter", trackMousePosition);
		document.addEventListener("mouseleave", trackMousePosition);
		document.addEventListener("click", trackClick);
		return () => {
			document.removeEventListener("mousemove", trackMousePosition);
			document.removeEventListener("mouseenter", trackMousePosition);
			document.removeEventListener("mouseleave", trackMousePosition);
			document.removeEventListener("click", trackClick);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/*

    & Let's check if the page request is valid.

    */

	React.useEffect(() => {
		const propertyChecks = async () => {
			try {
				const response = await fetch(process.env.PRODUCTION_API_URL + "properties/check-page-request", {
					method: "POST",
					body: JSON.stringify({
						slug: slug,
						dbUser: server_session ? server_session.user.dbUser : null,
						search_log_id: router.query
							? router.query.search_log_id
								? router.query.search_log_id
								: undefined
							: undefined,
					}),
				});

				const data = await response.json();

				if (data.is_404) {
					setIs404(true);
					router.push("/404", undefined, { shallow: true });
					return;
				}

				if (data.loggedIn) {
					setNotLoggedIn(true);
					signIn();
					return;
				}

				if (data.property_data) {
					setPageRequest(true);
				}
			} catch (error) {
				console.error("Error:", error);
			}
		};

		propertyChecks();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [server_session, router, slug]);

	/*

  & Let's declare the session id. We are using the session id to get the session id from the server session.

  */

	const sessionId = server_session ? (server_session.session_id ? server_session.session_id : "") : "";

	const { ref: property_details_ref, inView: propertyDetails_inView } = useInView({
		threshold: 0,
		triggerOnce: true,
	});

	const { ref: single_property_overview_ref, inView: singlePropertyOverview_inView } = useInView({
		threshold: 0,
		triggerOnce: true,
	});

	const { ref: about_single_property_ref, inView: aboutSingleProperty_inView } = useInView({
		threshold: 0,
		triggerOnce: true,
	});

	const { ref: single_property_amenities_ref, inView: singlePropertyAmenities_inView } = useInView({
		threshold: 0.25,
		triggerOnce: true,
	});

	const { ref: single_property_developer_ref, inView: singlePropertyDeveloper_inView } = useInView({
		threshold: 0.25,
		triggerOnce: true,
	});

	const { ref: single_property_about_location_ref, inView: singlePropertyAboutLocation_inView } = useInView({
		threshold: 0.25,
		triggerOnce: true,
	});

	const { ref: single_property_location_coordinates_ref, inView: singlePropertyLocationCoordinates_inView } = useInView(
		{
			threshold: 0.25,
			triggerOnce: true,
		},
	);

	const { ref: single_property_vicinity_ref, inView: singlePropertyVicinity_inView } = useInView({
		threshold: 0.25,
		triggerOnce: true,
	});

	const { ref: single_property_neighbourhood_reviews_ref, inView: singlePropertyNeighbourhoodReviews_inView } =
		useInView({
			threshold: 0.25,
			triggerOnce: true,
		});

	const { ref: single_property_reviews_ref, inView: singlePropertyReviews_inView } = useInView({
		threshold: 0.25,
		triggerOnce: true,
	});

	const { ref: single_property_creator_ref, inView: singlePropertyCreator_inView } = useInView({
		threshold: 0,
		triggerOnce: true,
	});

	const { ref: single_property_hot_properties_ref, inView: singlePropertyHotProperties_inView } = useInView({
		threshold: 0,
		triggerOnce: true,
	});

	const { ref: single_property_trending_properties_ref, inView: singlePropertyTrendingProperties_inView } = useInView({
		threshold: 0,
		triggerOnce: true,
	});

	/*

	& Let's fetch images, creator details and also create view.

	*/
	React.useEffect(() => {
		const clearAllFilters = () => {
			Object.keys(search_filter_state).filter((key) => {
				dispatch(updateSearchFilterAppliedThunk({ searchFilterId: key as SearchFilterId, isApplied: false }));
				dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: key as SearchFilterId, newOptions: [] }));
			});
		};
		if (initialLoad) {
			clearAllFilters();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialLoad]);

	React.useEffect(() => {
		if (!is_404 && pageRequest && !not_logged_in) {
			dispatch(
				fetchSinglePropertyImagesThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);

			dispatch(
				fetchSinglePropertyCreatorThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
			dispatch(
				fetchSinglePropertyLocationCoordinatesThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
			dispatch(
				fetchSinglePropertyAmenitiesThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
			dispatch(setImageCategoryThunk("all_images"));

			setInitialLoad(false);
		}
	}, [dispatch, sessionId, is_404, pageRequest, slug, not_logged_in]);

	React.useEffect(() => {
		if (
			propertyDetails_inView &&
			property_loading &&
			property_loading.propertyDetails &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyConfigAndAreaThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
			dispatch(
				fetchSinglePropertyDetailsThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		sessionId,
		redux_session,
		propertyDetails_inView,
		property_loading,
		is_404,
		pageRequest,
		slug,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			singlePropertyOverview_inView &&
			property_loading?.singlePropertyOverview &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyOverviewThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyOverview_inView,
		property_loading?.singlePropertyOverview,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			aboutSingleProperty_inView &&
			property_loading &&
			property_loading.aboutSingleProperty &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchAboutSinglePropertyThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
			dispatch(
				fetchSinglePropertyVicinityThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		aboutSingleProperty_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	// React.useEffect(() => {
	// 	if (
	// 		singlePropertyAboutLocation_inView &&
	// 		property_loading &&
	// 		property_loading.singlePropertyAboutLocation &&
	// 		!is_404 &&
	// 		pageRequest &&
	// 		!not_logged_in
	// 	) {
	// 		dispatch(
	// 			fetchSinglePropertyAboutLocationThunk({
	// 				slug: slug,
	// 				sessionId: sessionId,
	// 			}),
	// 		);
	// 		dispatch(
	// 			fetchDevelopersThunk({
	// 				slug: slug,
	// 				sessionId: sessionId,
	// 			}),
	// 		);
	// 		dispatch(
	// 			fetchNearbyPropertiesThunk({
	// 				slug: slug,
	// 				sessionId: sessionId,
	// 			}),
	// 		);
	// 	}
	// }, [
	// 	dispatch,
	// 	slug,
	// 	sessionId,
	// 	redux_session,
	// 	singlePropertyAboutLocation_inView,
	// 	property_loading,
	// 	is_404,
	// 	pageRequest,
	// 	not_logged_in,
	// ]);

	React.useEffect(() => {
		if (
			singlePropertyAmenities_inView &&
			property_loading &&
			property_loading.singlePropertyAmenities &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyAmenitiesThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
			// dispatch(
			// 	fetchDevelopersThunk({
			// 		slug: slug,
			// 		sessionId: sessionId,
			// 	}),
			// );
			// dispatch(
			// 	fetchNearbyPropertiesThunk({
			// 		slug: slug,
			// 		sessionId: sessionId,
			// 	}),
			// );
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyAmenities_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			singlePropertyDeveloper_inView &&
			property_loading &&
			property_loading.singlePropertyDeveloper &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyDeveloperThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		sessionId,
		redux_session,
		singlePropertyDeveloper_inView,
		property_loading,
		is_404,
		pageRequest,
		slug,
		not_logged_in,
	]);

	// React.useEffect(() => {
	// 	if (
	// 		singlePropertyLocationCoordinates_inView &&
	// 		property_loading &&
	// 		property_loading.singlePropertyLocationCoordinates &&
	// 		!is_404 &&
	// 		pageRequest &&
	// 		!not_logged_in
	// 	) {
	// 		dispatch(
	// 			fetchSinglePropertyLocationCoordinatesThunk({
	// 				slug: slug,
	// 				sessionId: sessionId,
	// 			}),
	// 		);
	// 	}
	// }, [
	// 	dispatch,
	// 	slug,
	// 	sessionId,
	// 	redux_session,
	// 	singlePropertyLocationCoordinates_inView,
	// 	property_loading,
	// 	is_404,
	// 	pageRequest,
	// 	not_logged_in,
	// ]);

	React.useEffect(() => {
		if (
			singlePropertyReviews_inView &&
			property_loading &&
			property_loading.singlePropertyReviews &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyReviewsThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyReviews_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			singlePropertyVicinity_inView &&
			property_loading &&
			property_loading.singlePropertyVicinity &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyVicinityThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyVicinity_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			singlePropertyNeighbourhoodReviews_inView &&
			property_loading &&
			property_loading.singlePropertyNeighbourhoodReviews &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyNeighbourhoodReviewsThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyNeighbourhoodReviews_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			singlePropertyTrendingProperties_inView &&
			property_loading &&
			property_loading.singlePropertyTrendingProperties &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyTrendingPropertiesThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyTrendingProperties_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	React.useEffect(() => {
		if (
			singlePropertyHotProperties_inView &&
			property_loading &&
			property_loading.singlePropertyHotProperties &&
			!is_404 &&
			pageRequest &&
			!not_logged_in
		) {
			dispatch(
				fetchSinglePropertyHotPropertiesThunk({
					slug: slug,
					sessionId: sessionId,
				}),
			);
		}
	}, [
		dispatch,
		slug,
		sessionId,
		redux_session,
		singlePropertyHotProperties_inView,
		property_loading,
		is_404,
		pageRequest,
		not_logged_in,
	]);

	/*

		& Let's start the view tracking process.
	    & Let's declare the owner. We are using the owner to check if the user is the owner of the property.

	*/

	const owner = redux_session
		? redux_session.user
			? redux_session.user.dbUser
				? redux_session.user.dbUser._id === property?.property.created_by.user_id
					? true
					: false
				: false
			: false
		: false;

	const [viewUpdated, setViewUpdated] = React.useState<boolean>(false);

	let ws = React.useRef<any>();

	const creator_user_id: string | ObjectId | UserInterface | BusinessProfileInterface = (
		property?.property as LocalPropertyInterface
	).created_by
		? (property?.property as LocalPropertyInterface).created_by.is_business_profile
			? (property?.property as LocalPropertyInterface).created_by.business_profile_id != ""
				? ((property?.property as LocalPropertyInterface).created_by.business_profile_id as BusinessProfileInterface)
						._id
				: ((property?.property as LocalPropertyInterface).created_by.business_profile_id as string)
			: (property?.property as LocalPropertyInterface).created_by.user_id != ""
				? ((property?.property as LocalPropertyInterface).created_by.user_id as UserInterface)._id
				: ((property?.property as LocalPropertyInterface).created_by.user_id as string)
		: "";

	React.useEffect(() => {
		if (reduxSessionUpdated && !owner && property?.property?._id !== "" && !is_404 && pageRequest) {
			/*

				& Let's track the view on this page by calling the openViewTrackingWebsocket() function.

			*/

			openViewTrackingWebsocket(
				dispatch,
				ws,
				view_time_spent_id,
				viewUpdated,
				setViewUpdated,
				creator_user_id,
				"property",
				property ? (property.property ? property.property._id : oid) : oid,
				redux_session !== null ? true : false,
				redux_session
					? redux_session.user
						? redux_session.user.dbUser
							? redux_session.user.dbUser.profile_context
								? redux_session.user.dbUser.profile_context.is_business_profile
								: false
							: false
						: false
					: false,
				redux_session
					? redux_session.user
						? redux_session.user.dbUser
							? redux_session.user.dbUser._id
							: oid
						: oid
					: oid,
				redux_session
					? redux_session.user
						? redux_session.user.dbUser
							? redux_session.user.dbUser.profile_context
								? redux_session.user.dbUser.profile_context.business_profile_id
								: oid
							: oid
						: oid
					: oid,
				sessionId,
				redux_session ? redux_session.ip_address : "",
				redux_session ? redux_session.user_agent : "",
				router.query ? (("https://beegru.com/properties/" + router.query.slug) as string) : "",
			);
		}

		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [reduxSessionUpdated, view_time_spent_id, property?.property?._id, owner, is_404, pageRequest]);

	/*

 		& Now let's check editor access to the property

  	*/

	const adminAccess: adminInterface | string | ObjectId =
		property?.property.created_by.business_profile_id !== ""
			? (property?.property.created_by.business_profile_id as ObjectId)
			: { _id: "", admins: [] };

	const logged_user: ObjectId | string = redux_session
		? redux_session.user
			? redux_session.user.dbUser
				? redux_session.user.dbUser._id
					? redux_session.user.dbUser._id
					: ""
				: ""
			: ""
		: "";

	const logged_user_access: string = redux_session
		? redux_session.user
			? redux_session.user.dbUser
				? redux_session.user.dbUser
					? redux_session.user.dbUser.access_level
						? redux_session.user.dbUser.access_level
						: ""
					: ""
				: ""
			: ""
		: "";

	let isEditor =
		(logged_user_access.includes("admin") &&
			logged_user_access.includes("property") &&
			property?.property.assigned_to.includes(logged_user)) ||
		(logged_user_access.includes("admin") && logged_user_access.includes("property_all")) ||
		logged_user_access.includes("super_admin")
			? true
			: property?.property.is_ofb
				? false
				: (adminAccess as adminInterface).admins?.find((admin: any) =>
						profile_context
							? profile_context.is_business_profile !== true
								? profile_context.user_id === admin.user_id
								: false
							: false,
					) !== undefined;

	const profile_context_user = profile_context
		? profile_context.is_business_profile
			? profile_context.business_profile_id
			: profile_context.user_id
		: null;

	const is_user_creator: boolean =
		profile_context_user !== ""
			? creator_user_id !== ""
				? profile_context_user === creator_user_id
					? true
					: false
				: false
			: false;

	if (is_404) {
		return (
			<Four0Four
				session={redux_session}
				theme={theme}
				showInactivityDialog={false}
				dispatch={dispatch}
				new_listing_url={new_listing_url ? new_listing_url : ""}
				bottom_buy_subscription={bottom_beegru_points}
			/>
		);
	}

	// const [hot_properties, setHotProperties] = React.useState<Array<any>>([property?.hotProperties]);

	return (
		<React.Fragment>
			<Layout
				keywords={metadata ? metadata.keywords : undefined}
				title={metadata ? metadata.title : undefined}
				description={metadata ? metadata.description : undefined}
				propertyData={property ? property.property : fallback_single_property_page.property}
				ogImageParams={{
					ogImageSquareUrl:
						metadata && metadata.openGraphImages && metadata.openGraphImages[0].url
							? metadata.openGraphImages[0].url
							: "",
					ogImageRectangleUrl:
						metadata && metadata.openGraphImages && metadata.openGraphImages[1].url
							? metadata.openGraphImages[1].url
							: "",
					ogImageSquareType:
						metadata && metadata.openGraphImages && metadata.openGraphImages[0].mimeType
							? metadata.openGraphImages[0].mimeType
							: "image/jpeg",
					ogImageRectangleType:
						metadata && metadata.openGraphImages && metadata.openGraphImages[1].mimeType
							? metadata.openGraphImages[1].mimeType
							: "image/jpeg",
					ogImageSquareWidth:
						metadata && metadata.openGraphImages && metadata.openGraphImages[0].size
							? metadata.openGraphImages[0].size.width
							: 512,
					ogImageSquareHeight:
						metadata && metadata.openGraphImages && metadata.openGraphImages[0].size
							? metadata.openGraphImages[0].size.height
							: 512,
					ogImageRectangleWidth:
						metadata && metadata.openGraphImages && metadata.openGraphImages[1].size
							? metadata.openGraphImages[1].size.width
							: 1200,
					ogImageRectangleHeight:
						metadata && metadata.openGraphImages && metadata.openGraphImages[1].size
							? metadata.openGraphImages[1].size.height
							: 630,
				}}
				canonicalUrl={process.env.PRODUCTION_URL + router.asPath.substring(1)}
				session={redux_session}
				redux_session_updated={reduxSessionUpdated}
				showInactivityDialog={showInactivityDialog}
				theme={theme}
				dispatch={dispatch}
				profile_context={profile_context}
				new_business_profile_url={new_business_profile_url ? new_business_profile_url : ""}
				new_listing_url={new_listing_url ? new_listing_url : ""}
				notifications={notification_data ? notification_data : notifications_page}
				new_notification={newNotification ? newNotification : null}
				bottom_nav_type="property"
				MainOgDescription={metadata ? metadata.mainOgDescription : undefined}
				newPropertyData={newPropertyData}
				newServiceData={newServiceData}
				bottom_buy_subscription={bottom_beegru_points ? bottom_beegru_points : bottom_subscribe_buy_beegru_points}
				login_flow_global_state={login_flow_global_state}
			>
				<div
					style={{
						paddingTop: "4rem",
						paddingBottom: "4rem",
					}}
				>
					<ContainerOne>
						<PropertyTitleSection
							propertyData={
								property && property.property
									? (property.property as LocalPropertyInterface)
									: fallback_single_property_page.property
							}
							dispatch={dispatch}
							session={redux_session}
							index={index}
							profile_context={profile_context}
							isEditor={isEditor}
							loading={property_loading ? (property_loading.singlePropertyImages as boolean) : true}
							saved_content={property?.property.saved_content as LocalPropertyInterface["saved_content"]}
							property_snackbar={property_snackbar as PropertySnackbarInterface}
							login_flow_global_state={login_flow_global_state}
						/>
						<SectionTwo
							propertyData={property ? property : fallback_single_property_page}
							dispatch={dispatch}
							session={redux_session}
							redux_session_updated={reduxSessionUpdated}
							location={location ? location : fallback_location}
							profile_context={profile_context}
							isEditor={isEditor}
							section_to_edit={sectionToEdit ? sectionToEdit : section_to_edit}
							data_before_edit={dataBeforeEdit ? dataBeforeEdit : data_before_edit}
							initialLoad={initialLoad}
							loading_property_images={property_loading ? (property_loading.singlePropertyImages as boolean) : true}
							loading_property_details={property_loading ? (property_loading.singlePropertyImages as boolean) : true}
							loading_property_config_and_area={
								property_loading ? (property_loading.singlePropertyImages as boolean) : true
							}
							loading_about_property={property_loading ? (property_loading.singlePropertyImages as boolean) : true}
							loading_overview={property_loading ? (property_loading.singlePropertyImages as boolean) : true}
							loading_amenity={property_loading ? (property_loading.singlePropertyAmenities as boolean) : true}
							loading_about_developer={property_loading ? (property_loading.singlePropertyDeveloper as boolean) : true}
							loading_about_location={
								property_loading ? (property_loading.singlePropertyAboutLocation as boolean) : true
							}
							loading_reviews={property_loading ? (property_loading.singlePropertyReviews as boolean) : true}
							loading_vicinity={property_loading ? (property_loading.singlePropertyVicinity as boolean) : true}
							loading_neighbourhood_reviews={
								property_loading ? (property_loading.singlePropertyNeighbourhoodReviews as boolean) : true
							}
							loading_property_creator={property_loading ? (property_loading.singlePropertyCreator as boolean) : true}
							loading_map={property_loading ? (property_loading.singlePropertyLocationCoordinates as boolean) : true}
							property_detailsInnerRef={property_details_ref}
							overviewInnerRef={single_property_overview_ref}
							aboutPropertyInnerRef={about_single_property_ref}
							amenitiesInnerRef={single_property_amenities_ref}
							aboutDeveloperInnerRef={single_property_developer_ref}
							aboutLocationInnerRef={single_property_about_location_ref}
							locationCoordinatesInnerRef={single_property_location_coordinates_ref}
							vicinityInnerRef={single_property_vicinity_ref}
							neighbourhoodReviewsInnerRef={single_property_neighbourhood_reviews_ref}
							reviewsInnerRef={single_property_reviews_ref}
							creatorInnerRef={single_property_creator_ref}
							property_snackbar={property_snackbar as PropertySnackbarInterface}
							propertyDetails_inView={propertyDetails_inView}
							singlePropertyOverview_inView={singlePropertyOverview_inView}
							aboutSingleProperty_inView={aboutSingleProperty_inView}
							singlePropertyAmenities_inView={singlePropertyAmenities_inView}
							singlePropertyDeveloper_inView={singlePropertyDeveloper_inView}
							singlePropertyAboutLocation_inView={singlePropertyAboutLocation_inView}
							singlePropertyReviews_inView={singlePropertyReviews_inView}
							singlePropertyVicinity_inView={singlePropertyVicinity_inView}
							singlePropertyLocationCoordinates_inView={singlePropertyLocationCoordinates_inView}
							is_user_creator={is_user_creator}
							logged_user_access={logged_user_access}
							logged_user={logged_user}
							saved_content={property?.property.saved_content as LocalPropertyInterface["saved_content"]}
							login_flow_global_state={login_flow_global_state}
						/>
					</ContainerOne>
					{is_user_creator || isEditor ? null : (
						<div
							style={{
								display: "flex",
								flexDirection: "column",
							}}
						>
							<CardCarousel
								data={property?.hotProperties as StateInterface["single_property_page"]["hotProperties"]}
								loading={property_loading ? (property_loading.singlePropertyHotProperties as boolean) : true}
								type="featured_properties"
								profile_context={profile_context}
								dispatch={dispatch}
								session={redux_session}
								innerRef={single_property_hot_properties_ref}
								login_flow_global_state={login_flow_global_state}
							/>

							<SuggestedPropertiesScorll
								slug_id={
									property && property.property && property?.property?._id ? property.property._id.toString() : ""
								}
								property_title={property && property.property && property.property.title ? property.property.title : ""}
								search_filter_state={search_filter_state}
								dispatch={dispatch}
								transaction_type={
									property && property.property && property.property.transaction_type
										? property.property.transaction_type
										: ""
								}
								property_type={
									property && property.property && property.property.property_type
										? property.property.property_type[0]
										: ""
								}
								property_category={
									property && property.property && property.property.property_category
										? property.property.property_category
										: ""
								}
								location_title={
									property && property.property && property.property.location && property.property.location.title
										? property.property.location.title
										: ""
								}
								location_coordinates={
									property &&
									property.property &&
									property.property.search_metrics &&
									property.property.search_metrics.location_coordinates
										? [
												property.property.search_metrics.location_coordinates[0],
												property.property.search_metrics.location_coordinates[1],
											]
										: []
								}
								redux_session={redux_session}
								profile_context={profile_context}
								search_filter_metrices={search_filter_metrices}
								search_api_response={SeacrhApiResponse}
								login_flow_global_state={login_flow_global_state}
							/>
						</div>
					)}
					<Fabs
						session={redux_session}
						dispatch={dispatch}
						propertyData={property ? property : fallback_single_property_page}
						profile_context={profile_context}
					/>
				</div>
			</Layout>
		</React.Fragment>
	);
};

export default connect(
	({
		globalState: {
			single_property_page,
			category,
			location,
			profile_context,
			new_listing_url,
			new_business_profile_url,
			section_to_edit,
			data_before_edit,
			property_loading,
			property_snackbar,
			notifications_page,
			redux_session,
			view_time_spent_id,
			new_property_data,
			new_service_data,
			search_animation_settings,
			bottom_subscribe_buy_beegru_points,
			search_filters_state,
			search_filter_metrices,
			SeacrhApiResponse,
			login_flow_global_state,
		},
	}: {
		globalState: {
			single_property_page: StateInterface["single_property_page"];
			category: StateInterface["category"];
			location: StateInterface["location"];
			profile_context: StateInterface["profile_context"];
			new_listing_url: StateInterface["new_listing_url"];
			new_business_profile_url: StateInterface["new_business_profile_url"];
			section_to_edit: StateInterface["section_to_edit"];
			data_before_edit: StateInterface["data_before_edit"];
			property_loading: StateInterface["property_loading"];
			property_snackbar: StateInterface["property_snackbar"];
			notifications_page: StateInterface["notifications_page"];
			redux_session: StateInterface["redux_session"];
			view_time_spent_id: StateInterface["view_time_spent_id"];
			new_property_data: StateInterface["new_property_data"];
			new_service_data: StateInterface["new_service_data"];
			search_animation_settings: StateInterface["search_animation_settings"];
			bottom_subscribe_buy_beegru_points: StateInterface["bottom_subscribe_buy_beegru_points"];
			search_filters_state: StateInterface["search_filters_state"];
			search_filter_metrices: StateInterface["search_filter_metrices"];
			SeacrhApiResponse: StateInterface["SeacrhApiResponse"];
			login_flow_global_state: StateInterface["login_flow_global_state"];
		};
	}) => ({
		property: single_property_page,
		category: category,
		location: location,
		profile_context: profile_context,
		new_listing_url: new_listing_url,
		new_business_profile_url: new_business_profile_url,
		sectionToEdit: section_to_edit,
		dataBeforeEdit: data_before_edit,
		property_loading: property_loading,
		property_snackbar: property_snackbar,
		notification_data: notifications_page,
		redux_session: redux_session,
		view_time_spent_id: view_time_spent_id,
		newPropertyData: new_property_data,
		newServiceData: new_service_data,
		searchanimationsettings: search_animation_settings,
		bottom_beegru_points: bottom_subscribe_buy_beegru_points,
		search_filter_state: search_filters_state,
		search_filter_metrices: search_filter_metrices,
		SeacrhApiResponse: SeacrhApiResponse,
		login_flow_global_state: login_flow_global_state,
	}),
)(Properties);
